module.exports = __webpack_public_path__ + "img/horizontal_7_5_4.a06d970d.png";